(function($) {
"use strict";
  $('.p_hero_slider').slick({
  autoplay: true,
  speed: 800,
  draggable:true,
  pauseOnFocus:false,
  pauseOnHover:false,
  arrows: false,
  dots: true,
});
 // condition for tab click
  $(".tabs-stage .tab_content").hide();
        $(".tabs-stage .tab_content:first").show();
        $(".tabs-stage .tab_content:first").addClass("active");
        $(".s_tabs_nav li:first").addClass("active");

        // condition for tab click
        $(".s_tabs_nav a").on("click", function (event) {
          event.preventDefault();
          $(".s_tabs_nav li").removeClass("active");
          $(this).parent().addClass("active");
          $(".tabs-stage .tab_content").hide();
          $(".tabs-stage .tab_content").removeClass("active");
          $($(this).attr("href")).addClass("active");
          $($(this).attr("href")).fadeIn();
        });
   // condition end for tab click

   // brands Slider

   $('.brans_slider').slick({
      autoplay: true,
      speed: 800,
      draggable:true,
      pauseOnFocus:false,
      pauseOnHover:false,
      arrows: true,
      dots: false,
     slidesToShow: 6,
    nextArrow: '<span class="next"><i class="fa fa-angle-right"></i></span>',
    prevArrow: '<span class="prev"><i class="fa fa-angle-left"></i></span>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }
  ]
  });

  // Collection Slider

   $('.f_collection_carousel').slick({
      autoplay: true,
      speed: 900,
      draggable:true,
      pauseOnFocus:false,
      pauseOnHover:false,
      arrows: true,
      dots: false,
     slidesToShow: 6,
    nextArrow: '<span class="next"><i class="fa fa-angle-right"></i></span>',
    prevArrow: '<span class="prev"><i class="fa fa-angle-left"></i></span>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2
      }
    }
  ]
  });
   // condition end for tab click
   // Starting condition when page loads
        $(".tabs-body .tab_content").hide();
        $(".tabs-body .tab_content:first").show();
        $(".tabs-body .tab_content:first").addClass("active");
        $(".a_tabs_nav li:first").addClass("active");

        // condition for tab click
        $(".a_tabs_nav a").on("click", function (event) {
          event.preventDefault();
          $(".a_tabs_nav li").removeClass("active");
          $(this).parent().addClass("active");
          $(".tabs-body .tab_content").hide();
          $(".tabs-body .tab_content").removeClass("active");
          $($(this).attr("href")).addClass("active");
          $($(this).attr("href")).fadeIn();
        });
  /// accordian
 $(".acc-head").on("click", function() {
    $(this).toggleClass("active");
    $(this).next().slideToggle(200);
  });
  

       // $(".acc-container .acc:nth-child(1) .acc-head").addClass("active");
       // $(".acc-container .acc:nth-child(1) .acc-content").slideDown();
      //  $(".acc-head").on("click", function () {
        //  if ($(this).hasClass("active")) {
         //   $(this).siblings(".acc-content").slideUp();
         //   $(this).removeClass("active");
       ///   } else {
           // $(".acc-content").slideUp();
           // $(".acc-head").removeClass("active");
          //  $(this).siblings(".acc-content").slideToggle();
           // $(this).toggleClass("active");
          //}
       // });
  
})(jQuery);